import { DAPI_HOST } from '../../config/index';

export const getBookingNotesUrl = (bookingId: any) => `${DAPI_HOST}/v1/bookings/${bookingId}/notes`;
